class IPAddress {
    constructor () {
        this.state = {
            ip:'https://demoapiformoviedb.herokuapp.com'
            //ip:'http://192.168.43.243:5000'
        }
    }
}

export default IPAddress